exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error{min-height:calc(100vh - 72px);height:100%;display:flex;justify-content:center;align-items:center;flex-direction:column}.error__title{font-weight:300;text-align:center}.error__copy{margin-top:40px;font-size:25px;font-weight:300;text-align:center}.error__copy a{color:#000;font-weight:400}.error hr{margin:60px auto;width:100px}.error button{margin:0 auto;display:block;text-decoration:underline}", ""]);

// exports
